/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type TitleCell_ScheduleFragment = { __typename: 'Schedule', id: string, title: string };

export const TitleCell_ScheduleFragmentDoc = gql`
    fragment TitleCell_schedule on Schedule {
  id
  title
}
    `;